import { createAction, props } from '@ngrx/store';
import { IKegtron } from 'app/models/kegtron';

export const clearAllItems = createAction('[DalHelper] Clear All Kegtron');
export const loadItems = createAction('[Settings Kegtron List Page] Load Kegtron', props<{ barId: string; forceRefresh?: boolean }>());
export const loadItemsSuccess = createAction('[Kegtron API] Load Kegtron Success', props<{ items: IKegtron[] }>());
export const loadItemsFailure = createAction('[Kegtron API] Load Kegtron Failure', props<{ error: any }>());
